import { makeActionCreator } from '../../../utilities'
import { AddMedicationAdministeredConstants } from './addMedicationAdministered.constants'

export const onSelectMedicationAdministered = makeActionCreator(
  AddMedicationAdministeredConstants.ON_SELECT_MEDICATION_ADMINISTERED,
  'date'
)
export const setDate = makeActionCreator(AddMedicationAdministeredConstants.SET_DATE, 'date')
export const setTime = makeActionCreator(AddMedicationAdministeredConstants.SET_TIME, 'time')
export const setAssessedBy = makeActionCreator(AddMedicationAdministeredConstants.SET_ASSESSED_BY, 'assessedBy')
export const setMedication = makeActionCreator(
  AddMedicationAdministeredConstants.SET_MEDICATION,
  'medication',
  'medicationAdministered',
  'iOptionValue'
)
export const setDose = makeActionCreator(AddMedicationAdministeredConstants.SET_DOSE, 'dose', 'medicationAdministered')
export const setDoseUnit = makeActionCreator(
  AddMedicationAdministeredConstants.SET_DOSE_UNIT,
  'doseUnit',
  'medicationAdministered'
)
export const setDoseUnitPNNV = makeActionCreator(
  AddMedicationAdministeredConstants.SET_DOSE_UNIT_PNNV,
  'doseUnitPNNV',
  'medicationAdministered'
)
export const setRate = makeActionCreator(AddMedicationAdministeredConstants.SET_RATE, 'rate', 'medicationAdministered')
export const setRateUnit = makeActionCreator(
  AddMedicationAdministeredConstants.SET_RATE_UNIT,
  'rateUnit',
  'medicationAdministered'
)

export const setRoute = makeActionCreator(
  AddMedicationAdministeredConstants.SET_ROUTE,
  'route',
  'medicationAdministered'
)
export const setRoutePNNV = makeActionCreator(
  AddMedicationAdministeredConstants.SET_ROUTE_PNNV,
  'routePNNV',
  'medicationAdministered'
)
export const setConcentration = makeActionCreator(
  AddMedicationAdministeredConstants.SET_CONCENTRATION,
  'concentration',
  'medicationAdministered'
)
export const setResponseValue = makeActionCreator(
  AddMedicationAdministeredConstants.SET_RESPONSE_VALUE,
  'response',
  'medicationAdministered'
)
export const setResponseValuePNNV = makeActionCreator(
  AddMedicationAdministeredConstants.SET_RESPONSE_VALUE_PNNV,
  'responsePNNV',
  'medicationAdministered'
)
export const setComplications = makeActionCreator(
  AddMedicationAdministeredConstants.SET_COMPLICATIONS,
  'complications',
  'medicationAdministered'
)
export const setAuthorization = makeActionCreator(
  AddMedicationAdministeredConstants.SET_AUTHORIZATION,
  'authorization',
  'medicationAdministered'
)

export const setWasted = makeActionCreator(
  AddMedicationAdministeredConstants.SET_WASTED,
  'wasted',
  'medicationAdministered'
)
export const setLotNumber = makeActionCreator(
  AddMedicationAdministeredConstants.SET_LOT_NUMBER,
  'lotNumber',
  'medicationAdministered'
)
export const setWitness1 = makeActionCreator(
  AddMedicationAdministeredConstants.SET_WITNESS_1,
  'witness1',
  'medicationAdministered'
)
export const setWitness2 = makeActionCreator(
  AddMedicationAdministeredConstants.SET_WITNESS_2,
  'witness2',
  'medicationAdministered'
)
export const deleteMedicationAdministered = makeActionCreator(
  AddMedicationAdministeredConstants.DELETE_MEDICATION_ADMINISTERED,
  'medicationAdministered'
)
export const saveMedicationAdministered = makeActionCreator(
  AddMedicationAdministeredConstants.SAVE_MEDICATION_ADMINISTERED
)
export const setComments = makeActionCreator(AddMedicationAdministeredConstants.SET_COMMENTS, 'comments')
export const addMedicationAdministered = makeActionCreator(
  AddMedicationAdministeredConstants.ADD_MEDICATION_ADMINISTERED
)
export const setMedicationAdministered = makeActionCreator(
  AddMedicationAdministeredConstants.SET_MEDICATION_ADMINISTERED,
  'medicationAdministered'
)
export const setCurrentMedication = makeActionCreator(
  AddMedicationAdministeredConstants.SET_CURRENT_MEDICATION,
  'currentMedication'
)
export const setAddMedicationAdministeredData = makeActionCreator(
  AddMedicationAdministeredConstants.SET_ADD_MEDICATION_ADMINISTERED_DATA,
  'addMedicationAdministeredData'
)
export const setResponse = makeActionCreator(AddMedicationAdministeredConstants.SET_RESPONSE, 'apiResponse')
export const setAreMedicationsOptionsLoading = makeActionCreator(
  AddMedicationAdministeredConstants.ARE_MEDICATIONS_OPTIONS_LOADING,
  'areMedicationsOptionsLoading'
)
export const setAddToTimeLine = makeActionCreator(
  AddMedicationAdministeredConstants.SET_ADD_TO_TIMELINE,
  'addToTimeline'
)
export const setState = makeActionCreator(
  AddMedicationAdministeredConstants.SET_STATE,
  'addMedicationAdministeredState'
)
export const resetState = makeActionCreator(AddMedicationAdministeredConstants.RESET_STATE)

export const setRolePerforming = makeActionCreator(
  AddMedicationAdministeredConstants.SET_ROLE_PERFORMING,
  'rolePerforming'
)
export const setRolePerformingPNNV = makeActionCreator(
  AddMedicationAdministeredConstants.SET_ROLE_PERFORMING_PNNV,
  'rolePerformingPNNV'
)
export const setAdministeredByAnotherUnit = makeActionCreator(
  AddMedicationAdministeredConstants.SET_ADMINISTERED_BY_OTHER_UNIT,
  'administeredByAnotherUnit'
)
export const setAdministeredByAnotherUnitPNNV = makeActionCreator(
  AddMedicationAdministeredConstants.SET_ADMINISTERED_BY_OTHER_UNIT_PNNV,
  'administeredByAnotherUnitPNNV'
)
export const setPTA = makeActionCreator(AddMedicationAdministeredConstants.SET_PTA, 'pta')
export const setMedicationDefaults = makeActionCreator(
  AddMedicationAdministeredConstants.SET_MEDICATION_DEFAULTS,
  'medicationDefaults'
)
